































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import { AccountQualificationOverride } from '@/api/accountqualificationdetails';
import { Cycle } from '@/api/cycles';
import { Account } from '@/api/consumeraccountdetails';
import { QualOverrideResource } from '@/api/qualoverride/QualOverrideResource';

interface QualificationDetailOverrideSelection {
  label: string,
  isOverride: boolean,
  level: number,
  isForAllFuture: boolean | null,
}

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
  },
})
export default class ForceQualifyControl extends Vue {
  @Prop() override!: AccountQualificationOverride;

  @Prop() cycle!: Cycle;

  @Prop() account!: Account;

  @Inject('QualOverrideResource')
  qualOverrideResource!: QualOverrideResource;

  fiId!: string;

  selectItems: QualificationDetailOverrideSelection[] = [];

  selection: QualificationDetailOverrideSelection | null = null;

  initialSelection: QualificationDetailOverrideSelection | null = null;

  saving: boolean = false;

  OverrideOptionConstants = {
    NO: 'No',
    SINGLE_LEVEL_CURRENT_CYCLE: 'Current Cycle',
    SINGLE_LEVEL_FUTURE_CYCLE: 'All Future Cycles',
    MULTI_LEVEL_CURRENT_PREFIX: 'Current Cycle Level ',
    MULTI_LEVEL_FUTURE_PREFIX: 'All Future Cycles Level ',
  };

  OVERRIDE_OPTION_NO: QualificationDetailOverrideSelection = {
    label: this.OverrideOptionConstants.NO,
    isOverride: false,
    level: 1,
    isForAllFuture: null,
  }

  singleLevelOverrideOptions: QualificationDetailOverrideSelection[] = [
    this.OVERRIDE_OPTION_NO,
    {
      label: this.OverrideOptionConstants.SINGLE_LEVEL_CURRENT_CYCLE,
      isOverride: true,
      level: 1,
      isForAllFuture: false,
    },
    {
      label: this.OverrideOptionConstants.SINGLE_LEVEL_FUTURE_CYCLE,
      isOverride: true,
      level: 1,
      isForAllFuture: true,
    },
  ];

  mounted() {
    this.calculateForceQualOptions();
  }

  isForSingleLevelProduct(): boolean {
    return this.override.highestQualLevelForProduct === 1;
  }


  @Watch('account')
  calculateForceQualOptions() {
    if (this.isForSingleLevelProduct()) {
      this.selectItems = this.singleLevelOverrideOptions;
    } else {
      this.selectItems = [this.OVERRIDE_OPTION_NO];
      for (let levelToCreateCurrentOptionFor = 1;
        levelToCreateCurrentOptionFor <= this.override.highestQualLevelForProduct;
        levelToCreateCurrentOptionFor++) {
        this.selectItems.push({
          label: this.OverrideOptionConstants.MULTI_LEVEL_CURRENT_PREFIX + levelToCreateCurrentOptionFor,
          isOverride: true,
          level: levelToCreateCurrentOptionFor,
          isForAllFuture: false,
        });
      }

      for (let levelToCreateFutureOptionFor = 1;
        levelToCreateFutureOptionFor <= this.override.highestQualLevelForProduct;
        levelToCreateFutureOptionFor++) {
        this.selectItems.push({
          label: this.OverrideOptionConstants.MULTI_LEVEL_FUTURE_PREFIX + levelToCreateFutureOptionFor,
          isOverride: true,
          level: levelToCreateFutureOptionFor,
          isForAllFuture: true,
        });
      }
    }

    this.calculateInitialSelectedOverrideOption();
  }


  calculateInitialSelectedOverrideOption() {
    if (!this.override.isOverride) {
      this.initialSelection = this.OVERRIDE_OPTION_NO;
    } else {
      const qualOverride = this.override;
      const newSelection: QualificationDetailOverrideSelection | undefined = this.selectItems.find((option: QualificationDetailOverrideSelection) => option.isForAllFuture === qualOverride.isOverrideAllFuture && option.level === qualOverride.overrideQualLevel);

      if (newSelection) {
        this.initialSelection = newSelection;
      } else {
        this.initialSelection = null;
      }
    }

    this.selection = this.initialSelection;
  }

  onSave() {
    this.saving = true;

    this.qualOverrideResource.deleteQualOverrideByAccounts(this.fiId, [this.account.accountKasasaKey],
      new Date(this.cycle.qualificationStartDate)).then(() => {
      // Save new
      if (this.selection && this.selection.isOverride) {
        this.qualOverrideResource.createQualOverrideForAccount(this.fiId, this.account.coreAccountNumber,
          this.account.externalProductMappingId, this.cycle, this.selection.isForAllFuture,
          this.selection.level).then(() => {
          this.initialSelection = this.selection;
        }).catch((error: any) => {
          this.showErrorMessage(error);
        }).finally(() => {
          this.saving = false;
        });
      } else if (this.selection && !this.selection.isOverride) {
        // No need to save anything, as we're just cancelling the override
        this.initialSelection = this.selection;
        this.saving = false;
      }
    }).catch((error: any) => {
      this.showErrorMessage(error);
    });
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
